module.exports = __webpack_public_path__ + "img/jl_top_dh.06252f62.png";